import {TranslatableRental} from "./locations";
import {mainPhotoStudio6, studio6photos} from "./photo";
import {studio6FR} from "./descriptions/fr/studio6";
import {studio6EN} from "./descriptions/en/studio6";

export const studio6: TranslatableRental = {
  name: {
    fr: "Appartement avec terrasse",
    en: "Apartment with terrace"
  },
  roomId: "501220",
  slugs: {
    fr: "appartement-avec-terrasse",
    en: "apartment-with-terrace"
  },
  description: {
    fr: studio6FR,
    en: studio6EN
  },
  lodgifyId: "435083",
  area: 45,
  capacity: 4,
  numberOfBeds: 1,
  numberOfBedrooms: 1,
  numberOfBathrooms: 1,
  equipments: [
    "ac",
    "tv",
    "wifi",
    "breakfast",
    "coffee-machine",
    "fridge",
    "heater",
    "kitchen-storage",
    "swimming",
    "toilet",
    "shower",
    "wheelchair-way",
    "parking",
    "microwave",
    "no-smoking",
    "hair-dryer",
    "iron",
    "kettle",
    "household-linen",
    "toaster"
  ],
  mainImage: mainPhotoStudio6,
  assets: studio6photos
}
